import { Component } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MainService } from 'src/app/services/main.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { ProjectsService } from 'src/app/services/projects.service';
import { ProjectsVoboAddComponent } from '../../shared/dialogs/projects-vobo-add/projects-vobo-add.component';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { UsersService } from 'src/app/services/users.service';
import { PhasesRedorderComponent } from '../../shared/dialogs/phases-reorder/phases-reorder.component';
import { ProjectsListCloneConfigComponent } from '../../shared/dialogs/project-list-clone-config/project-list-clone-config.component';

@Component({
  selector: 'app-project-config',
  templateUrl: './project-config.component.html',
  styleUrls: ['./project-config.component.scss']
})
export class ProjectConfigComponent {

  constructor(
    private matDialog: MatDialog,
    private main : MainService,
    private _params: ActivatedRoute,
    private _titleService: Title,
    private _router : Router,
    private projectService : ProjectsService,
    private userService : UsersService,
  ) { }

  id_campana_proyecto = 0;
  formList : any[] = [];
  usersList : any[] = [];
  // user_selected :  any[] = []; // Relacionado a la carga de Arte
  // filteredUsers: any[] = []; // Relacionado a la carga de Arte
  // userSearchTerm: string = ''; // Relacionado a la carga de Arte
  hasProveedor : boolean = false;
  fecha_inicio : Date = new Date();
  fecha_final: Date = new Date();
  hasDiagramas : boolean = false;


  ngOnInit(): void {
    this._params.params.subscribe(params => {
      if(params.id){

        this.id_campana_proyecto = params.id;
        this.loadFormularios();
        this.userService.getUserList().subscribe(
          (result : any) => {
         
            this.usersList = result;
            // this.filteredUsers = this.usersList.slice();
            this.main.HideLoading();
            this.loadProjectData();
          },
          (err : any) => {
            console.log(err);
            this.main.HideLoading();
          }
        );

      }else{
        this._router.navigateByUrl('/admin/dashboard');
      }
    });
  }

  project : any;
  haschanges : boolean = false;

  diagramacionItems = [
    { id: 1,  area: 'Juan Pérez', scheluded_time_days: 4, deleted : 0},
    { id: 2, area: 'Ana Gómez',  scheluded_time_days: 4, deleted : 0 },
    { id: 3,  area: 'Carlos Ruiz',  scheluded_time_days: 4, deleted : 0  },
  ];

  artesItems = [
    { id: 1,  area: 'Juan Pérez', scheluded_time_days: 4, deleted : 0 },
    { id: 2, area: 'Ana Gómez',  scheluded_time_days: 4, deleted : 0 },
    { id: 3,  area: 'Carlos Ruiz',  scheluded_time_days: 4, deleted : 0 }
  ];

  dataPhases : any;

  loadProjectData(){
    console.log("Project data", this._params.snapshot.data.data);
    this.main.HideLoading();

    if( this._params.snapshot.data.data ){
      if (this._params.snapshot.data.data.message = 'Success') {
        this.project = this._params.snapshot.data.data.data.project[0];
        this.hasDiagramas = this.project.total_diagramaciones > 0;
        
        this.fecha_inicio = new Date(this.project.fecha_inicio);
        this.dataPhases = this._params.snapshot.data.data.data.data;
        this.calculateLastDay()
         this.evaluateIfhasProveedor();
       }
    }else{
      this._router.navigateByUrl('/admin/dashboard');
    }
   }

   reloadProjectData(){
    this.main.ShowLoading();

    this.projectService.getConfigData(this.id_campana_proyecto).subscribe((x:any)=>{

      if (x.data.message = 'Success') {
        this.project = x.data.project[0];
        this.hasDiagramas = this.project.total_diagramaciones > 0;
         this.dataPhases = x.data.data;
         this.haschanges = false;
         this.calculateLastDay();
         this.evaluateIfhasProveedor();
       }

       this.main.HideLoading();
      
    });


   }

   loadFormularios(){
      this.projectService.getFormularios().subscribe((x:any)=>{
        this.formList = x.data;
      });
   }

  loadDiagramacionItems(){
    return this.diagramacionItems.filter((x:any)=> x.deleted == 0 );
  }

  loadArtesItems(){
    return this.artesItems.filter((x:any)=> x.deleted == 0 );
  }

  drop(list : any, event: CdkDragDrop<string[]>) {
    this.haschanges = true;
    moveItemInArray(list, event.previousIndex, event.currentIndex);

    list.forEach((item: any, index: number) => {
      item.order_id = index;
    });

    for (let i = 1; i < list.length; i++) {
      if (list[i].scheluded_time_days < list[i - 1].scheluded_time_days) {
        const tempDays = list[i].scheluded_time_days;
        list[i].scheluded_time_days = list[i - 1].scheluded_time_days;
        list[i - 1].scheluded_time_days = tempDays;
      }
    }
    this.calculateLastDay();
  }

  calculateLastDay(){
    let lastVoboDays = 0;
    if (this.dataPhases && this.dataPhases.length > 0) {
      for (let i = this.dataPhases.length - 1; i >= 0; i--) {
        const phase = this.dataPhases[i];
        if (phase.vobos && phase.vobos.length > 0) {
          const lastVobo = phase.vobos[phase.vobos.length - 1];
          if (lastVobo && lastVobo.scheluded_time_days) {
            lastVoboDays = lastVobo.scheluded_time_days;
            break; 
          }
        }
      }
    }

    const startDate = new Date(this.fecha_inicio);
    if (!isNaN(startDate.getTime())) {
      const finalDate = new Date(startDate);
      finalDate.setDate(startDate.getDate() + lastVoboDays);
      this.fecha_final = finalDate;
    }
    
  }

  addItem(lista : any){
    this.haschanges = true;
    const lastOrder = lista.length > 0 ? Math.max(...lista.map((item: any) => item.order_id)) : -1;
    let newVobo = {id: 0, area: '', scheluded_time_days: 0, id_campana_proyecto: this.id_campana_proyecto, deleted : 0, users: [], vobos: [], order_id : lastOrder + 1, optional : 0};

    this.openAddEditVobo(newVobo, lista, true);
  }

  addPhase(){
    Swal.fire({
      title: 'Nueva fase',
      html: `
        <input id="swal-input-name" class="swal2-input" placeholder="Nombre de la fase">
        <input id="swal-input-days" type="number" class="swal2-input" placeholder="Días programados">
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: `Confirmar`,
      cancelButtonText: `Cancelar`,
      preConfirm: () => {
        const name = (document.getElementById('swal-input-name') as HTMLInputElement).value.trim();
        const days = (document.getElementById('swal-input-days') as HTMLInputElement).value.trim();
    
        if (!name) {
          Swal.showValidationMessage('El nombre es necesario');
          return;
        }
    
        if (!days || isNaN(Number(days)) || Number(days) <= 0) {
          Swal.showValidationMessage('Ingrese un número válido de días');
          return;
        }
    
        return { name, days: Number(days) };
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const { name , days } = result.value as { name: string; days: number };
         this.dataPhases.push({id: 0, nombre : name.trim(), scheluded_time_days: days, id_campana_proyecto : this.id_campana_proyecto, vobos: [], is_provider_vobo : 0, optional : 0, deleted : 0});
         this.haschanges = true;
      }
  });
  }

  editPhase(phaseEdit : any){
    console.log(phaseEdit);
    Swal.fire({
      title: 'Editar fase',
      html: `
        <input id="swal-input-name" class="swal2-input" placeholder="Nombre de la fase" value="`+phaseEdit.nombre +`">
        <input id="swal-input-days" type="number" class="swal2-input" placeholder="Días programados" value=`+phaseEdit.scheluded_time_days?.toString() +`>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: `Confirmar`,
      cancelButtonText: `Cancelar`,
      preConfirm: () => {
        const name = (document.getElementById('swal-input-name') as HTMLInputElement).value.trim();
        const days = (document.getElementById('swal-input-days') as HTMLInputElement).value.trim();
    
        if (!name) {
          Swal.showValidationMessage('El nombre es necesario');
          return;
        }
    
        if (!days || isNaN(Number(days)) || Number(days) <= 0) {
          Swal.showValidationMessage('Ingrese un número válido de días');
          return;
        }
    
        return { name, days: Number(days) };
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const { name , days } = result.value as { name: string; days: number };
         phaseEdit.nombre = name;
         phaseEdit.scheluded_time_days = days;
         this.haschanges = true;
      }
  });

  }

  removeItem(item : any){
    this.haschanges = true;
    item.deleted = 1;
  }

  openAddEditVobo(vobo:any, lista : any = null, additem : boolean = false) {
    this.matDialog.open(ProjectsVoboAddComponent, {
      panelClass: ['dialogs-md'],
      disableClose: false,
      data: {
        vobo : vobo,
        users : this.usersList,
        forms : this.formList,
        hasProveedor : this.hasProveedor,
        lista: lista
      }
    }).afterClosed().subscribe(
      resp => {
      
          Object.assign(vobo, resp.vobo);
          console.log(resp, vobo, lista);
          if(additem){
            lista.push(vobo);
          }
          this.calculateLastDay();
           this.evaluateIfhasProveedor();
        }
     
      
    );
  }

  openCloneProyect() {
    this.matDialog.open(ProjectsListCloneConfigComponent, {
      panelClass: ['dialogs-md'],
      data: {
        proyecto_id : this.id_campana_proyecto,
      }
    }).afterClosed().subscribe(
      resp => {
        this.reloadProjectData();
      }
    );
  }

  openReorderPhases(){
    this.matDialog.open(PhasesRedorderComponent, {
      panelClass: ['dialogs-sm'],
      data: {
        phases : this.dataPhases,
        haschanges : this.haschanges
      }
    }).afterClosed().subscribe(
      resp => {
        this.calculateLastDay();
      }
    );
  }

  ruSure() {
    // Se comenta la validación de usuarios para carga de arte.
    // if(this.user_selected.length!= 0){
    Swal.fire({
      title: '¿Esta seguro que desea guardar la configuración?',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: `Confirmar`,
      cancelButtonText: `Cancelar`
    }).then((result) => {      
      if (result.isConfirmed) {
        Swal.fire({
          icon: 'info',
          title: 'Guardando...',
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
      
        this.projectService.saveProjectVobos({id_proy : this.id_campana_proyecto, users : "[]", phases: this.dataPhases, fecha_final : this.fecha_final.toISOString().slice(0, 10)}).subscribe(
          (result:any) => {
            if(result.message == "Success") {
              Swal.fire({
                icon: 'success',
                title: 'Guardado',
                text: 'Datos guardados correctamente'          
              }).then(() => {            
                this.reloadProjectData();
              });
            }
          },
          (err:any) => {
              console.log(err);
              Swal.fire({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
              });
            }
          
        );
      }
    });
    /* 
    }else{
      Swal.fire({
         icon: 'warning',
         title: 'No hay usuarios seleccionados',
        text: 'No se ha seleccionado ningún usuario para la carga de artes. Por favor, seleccione uno antes de guardar.'
      });
    }*/

  }


  addDiagramacion(){
    this.haschanges = true;
    let newVobo = {id: 0, area: '', scheluded_time_days: 0, id_campana_proyecto: this.id_campana_proyecto, deleted : 0, order_id : 0};
    this.diagramacionItems.push(newVobo)
    this.openAddEditVobo(newVobo);
  }

  addArtes(){
    this.haschanges = true;
    let newVobo = {id: 0, area: '', scheluded_time_days: 0, id_campana_proyecto: this.id_campana_proyecto, deleted : 0};
    this.artesItems.push(newVobo);
    this.openAddEditVobo(newVobo);
  }

  evaluateIfhasProveedor(){
    this.hasProveedor = false;
    this.dataPhases.forEach((phase : any) => {
        let thishasproveedor = phase.vobos.some((x:any) => x.is_provider_vobo == true && x.deleted == 0);
        if(thishasproveedor){
          this.hasProveedor = true;
        }
    });
  }

  hasPermissions(key : string, buho : boolean|any, client : boolean|any):  boolean {
    return this.projectService.hasPermissions(key, buho, client);
  }

  //areAllUsersSelected(): boolean {
  //  return this.user_selected.length === this.usersList.length;
  //}

  /* 
  filterUsers(): void {
    const searchTerm = this.userSearchTerm.toLowerCase();
    const selectedUserIds = new Set(this.user_selected);

    if (!searchTerm) {
      this.filteredUsers = this.usersList.slice();
      return;
    }

    const matchedUsers = this.usersList.filter(user =>
      user.name.toLowerCase().includes(searchTerm) || selectedUserIds.has(user.id)
    );
    this.filteredUsers = matchedUsers;
  }

  clearUserSearch(): void {
    this.userSearchTerm = '';
    this.filterUsers();
  }

  areAllFilteredUsersSelected(): boolean {
    const filteredIds = this.filteredUsers.map(u => u.id);
    return filteredIds.every(id => this.user_selected.includes(id));
  }


  toggleAllUsers(): void {
    const filteredIds = this.filteredUsers.map(u => u.id);
    if (this.areAllFilteredUsersSelected()) {
      this.user_selected = this.user_selected.filter((id: number) => !filteredIds.includes(id));
    } else {
      const newSelection = [...new Set([...this.user_selected, ...filteredIds])];
      this.user_selected = newSelection;
    }
  }
  */

}